import axios from "axios";

export default axios.create({
  baseURL: "https://advantis.insiteservices.com/advserver",
  headers: {
    "Content-type": "application/json"
  }
});